import Api from './Api';

const BASE_PATH = '/auth/api/v1/admin/bf/loginAttempt';

export default {

    // returns {total, offset, limit, items: [{key, keyType: 'USERNAME' | 'IP_ADDRESS', attempts, lockedAt, lockedUntil, associatedKeys, linkedIps}]}
    async getLockouts(offset, limit) {
        return new Api(true).get(BASE_PATH, {params: {offset, limit}});
    },

    // returns {clearedUsernames, clearedIps, retainedIps}
    async clear(usernames, ips, reason) {
        return new Api(true).post(BASE_PATH + '/clear', {usernames, ips, reason});
    },

    // clears every lockout across all orgs
    async clearAll(reason) {
        return new Api(true).delete(BASE_PATH, {params: {reason}});
    }
};
